import type { AssociationPreviewResult } from '@/domain/invoice/associationPreview'

export interface RawAssociationPreviewResult {
  invoice_id: number
  status: AssociationPreviewResult['status']
  reason: string | null
  detail: unknown
  destination: { request_id: number; society_id: number; purchase_order_id: number | null; line_mapping?: boolean } | null
}

/** Shared by the group write and the preview: both answer with the same `results` shape. */
export function toAssociationPreviewResult(raw: RawAssociationPreviewResult): AssociationPreviewResult {
  return {
    invoiceId: raw.invoice_id,
    status: raw.status,
    reason: raw.reason ?? null,
    detail: raw.detail ?? null,
    destination: raw.destination
      ? {
        requestId: raw.destination.request_id,
        societyId: raw.destination.society_id,
        purchaseOrderId: raw.destination.purchase_order_id ?? null,
        lineMapping: raw.destination.line_mapping ?? false,
      }
      : null,
  }
}
